import React from "react";
import {CountWithUnit} from "../../explore/topicsStat/component/CountWithUnit";
import _ from "lodash";

interface CellProps {
    count?: number,
    percent?: number,
    color?: string,
    nbDecimal?: number,
    nbDecimalPercent?: number,
    textAlign?: 'left' | 'right' | 'center',
}

export class Cell extends React.PureComponent<CellProps> {
    render() {
        let {count, percent, color, nbDecimal, nbDecimalPercent, textAlign} = this.props;
        const numStyle = {fontWeight: 800};
        const unitStyle = {fontWeight: 400};
        const countToDisplay = count || count === 0 ? _.isNil(nbDecimal) ? count : _.round(count, nbDecimal) : undefined;
        const align = _.isNil(textAlign) || textAlign === 'left'? 'flex-start' : ( textAlign === 'right' ? 'flex-end': 'center');

        return <div style={{color: color, display: 'flex', justifyContent: align}}>
            {percent ?
                <div style={{display: 'flex', justifyContent: 'left'}}>
                    <CountWithUnit i18nKey='misc.percent'
                                   count={_.round(percent, _.isNil(nbDecimalPercent) ? 2 : nbDecimalPercent)}
                                   countSpanStyle={numStyle}
                                   unitSpanStyle={unitStyle}/>
                </div> : null
            }
            {countToDisplay ? <span>{percent ? "\u00A0(" + countToDisplay + ")" : countToDisplay}</span> : null}
        </div>
    }
}